interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) {
    return (
      <div className="flex items-center justify-center mt-10 text-xs text-foreground-600">
        已显示全部结果
      </div>
    );
  }

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-2 mt-10 flex-wrap">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="h-9 px-3 rounded-md border border-background-300/60 text-sm text-foreground-300 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 whitespace-nowrap cursor-pointer"
      >
        上一页
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`w-9 h-9 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
            item === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-300/60 text-foreground-300 hover:bg-background-100"
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="h-9 px-3 rounded-md border border-background-300/60 text-sm text-foreground-300 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 whitespace-nowrap cursor-pointer"
      >
        下一页
      </button>
    </div>
  );
}